import { render, staticRenderFns } from "./DragResize.vue?vue&type=template&id=7d2c88e8"
import script from "./DragResize.vue?vue&type=script&lang=js"
export * from "./DragResize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports